


































































































import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import ActivityIndicator from '@/components/ActivityIndicator.vue';
import { CombatRoom, CombatHub, SocketState, World, User } from '@/types';
import api from '@/api';
import { ApiResponse } from 'apisauce';
import { TweenLite, Elastic } from 'gsap';

interface CombatRooms {
  [id: string]: CombatRoom;
}

@Component({
  components: { ActivityIndicator },
})
export default class Hub extends Vue {
  @State public world!: World;
  @State public user!: User;
  @State  public socket!: SocketState;
  @Action public SOCKET_EMIT: any;
  @State  public combatHub!: CombatHub;

  public combatHubConnection: -1 | 0 | 1 = -1; // -1 = err, 0 = pending, 1 = ok

  public availableCharacters = [
    {
      name: 'Adventurer',
      description: 'You\'re off on an adventure! But beware, here be dragons.',
      level: 0,
    },
    {
      name: 'Ninja',
      description: 'A sneaky ninja...',
      level: 300,
    },
  ];
  public currentCharacterIndex = 0;
  public combatData = {
    loaded: -1, // 1 = ok, 0 = pending, -1 = failed
  };

  public updated() {
    const { user, combatData, socket } = this;

    // on disconnect socket
    if (!socket.connected) {
      this.combatHubConnection = -1;
    }

    // combat hub connection attempt
    if (socket.connected && user.authenticated && this.combatHubConnection === -1) {
      this.combatHubConnection = 0;
      this.SOCKET_EMIT(['COMBAT_HUB_CONNECT', (err?: string) => {
        if (!err) {
          this.combatHubConnection = 1;
        } else {
          this.combatHubConnection = -1;
        }
      }])
    }
    // load combatData for user
    if (user.authenticated && combatData.loaded === -1) {
      this.combatData = { loaded: 0 };
      api.get(`combatant/${this.user.id}`)
      .then((res: ApiResponse<any>) => {
        const body = res.data;
        if (res.ok) {
          this.combatData = { ...body.data, loaded: 1 };
        } else {
          this.combatData = { loaded: -1 };
        }
      });
    }
  }
  public destroyed() {
    if (this.combatHubConnection === 1) {
      this.SOCKET_EMIT(['COMBAT_ROOM_DISCONNECT']);
    }
  }
  public setRoomsVisiblity(visibility: boolean) {
    const roomsContainerEl = document.getElementById('combat-rooms-container');
    const roomsEl = document.getElementById('combat-rooms');
    if (!roomsContainerEl || !roomsEl) {
      throw new Error('Missing elements to animate!');
    }

    if (visibility) {
      TweenLite.fromTo(roomsContainerEl, 0.2, { display: 'none', opacity: 0 }, { display: 'flex', opacity: 1 });
      TweenLite.fromTo(roomsEl, 1.2, { scale: 0 }, { scale: 1, ease: Elastic.easeOut.config(0.5, 0.5) });
    } else {
      TweenLite.fromTo(
        roomsContainerEl,
        0.25,
        { opacity: 1 },
        {
          opacity: 0,
          onComplete() {
            roomsContainerEl.style.display = 'none';
          },
        }
      );
      TweenLite.fromTo(roomsEl, 0.25, { scale: 1 }, { scale: 0 });
    }
  }
  public joinRoom(id: string) {
    this.$router.push(`/combat/${id}`);
  }
  public moveSelection(direction: number) {
    if (this.availableCharacters[this.currentCharacterIndex + direction]) {
      this.currentCharacterIndex += direction;
    }
  }
  get currentCharacter() {
    return this.availableCharacters[this.currentCharacterIndex];
  }
}
